import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    fontSize: [
      10,
      11,
      12,
      13,
      14,
      15,
      'default(16px)',
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      36,
      40,
      48,
      52,
      56,
      60,
      64,
      68,
      72,
      76,
      80
    ]
  },
  actions: {
  },
  getters: {
    getFontSize: state => state.fontSize
  }
}
